export default __webpack_public_path__ + "static/media/karimi.40278adf.jpg";